import { useQuery } from '@tanstack/react-query'
import { fetchPersonaState } from '../lib/api'
import { useSSEConnected } from './useSSE'

function toBareName(id: string): string {
  if (!id) return ''
  return id.toLowerCase().replace(/^pu-/, '')
}

export function useAwakePersonas(): Set<string> {
  const sseOk = useSSEConnected()
  const { data } = useQuery({
    queryKey: ['personaState'],
    queryFn: fetchPersonaState,
    refetchInterval: sseOk ? false : 30_000,
    staleTime: 10_000,
  })

  if (!data) return new Set()

  const awake = new Set<string>()
  for (const [name, state] of Object.entries(data)) {
    if (state.awake) awake.add(toBareName(name))
  }
  return awake
}

export function isAwake(awakeSet: Set<string>, id: string): boolean {
  return awakeSet.has(toBareName(id))
}
